import type { Dispatch, SetStateAction } from 'react';
import type { FilterValue, TableCurrentDataSource, TablePaginationConfig } from 'antd/es/table/interface';
import NamespaceEnum from "@/constants/NamespaceEnum";
import httpBaseConfig from '../api/base/httpBaseConfig';
import { ProColumns } from "@ant-design/pro-components";
import { USER_ID, TOKEN, DEV_ID, DEPT_ID, IS_TABLE_STYLE, LOGIN_INFO, PERM_INFO, DEPT_Name } from "@/constants/constants";
import SimpleStorage from '../global/SimpleStore';
import { message } from 'antd';

/** ProTable onChange：分页变化时不更新 params，避免 params 变化导致页码被重置 */
export function handleProTableParamsChange(
  setParams: Dispatch<SetStateAction<Record<string, unknown>>>,
  _pagination: TablePaginationConfig,
  filters: Record<string, FilterValue | null>,
  sorter: any,
  extra: TableCurrentDataSource<unknown>,
) {
  if (extra?.action === 'paginate') return;
  setParams({ filed: sorter.field, order: sorter.order, ...filters });
}

export function composeUrl(type: any) {
  let urls = httpBaseConfig.baseUrl

  switch (type) {
    case type == 'base':
      urls = httpBaseConfig.imgUrl;
      break;
    default:
      break;
  }

  return urls
}

export function composeBaseUrl() {
  const baseUrl = httpBaseConfig.baseUrl;
  const port = httpBaseConfig.port;
  const prefix = httpBaseConfig.prefix;
  //const microService = httpBaseConfig.microService;

  return `${baseUrl}${port}${prefix}`;
}
export function constructImportUrl(namespace: NamespaceEnum) {
  const baseUrl = composeBaseUrl();
  return `${baseUrl}${namespace}/import`;
}

// 轮播图

export function imgUploadUrls(subDir='') {
  const baseUrl = composeBaseUrl();
  if (subDir) {
    return `${baseUrl}/file/upload?subDir=${subDir}`;
  } else {
    return `${baseUrl}/file/upload`;
  }
}
export async function imgUploadUrl() {
  const baseUrl = composeBaseUrl();
  return `${baseUrl}minio/upload`;
}

export async function fileUploadUrl() {
  const baseUrl = composeBaseUrl();
  return `${baseUrl}minio/upload`;
}

export function minioUrl() {
  const baseUrl = httpBaseConfig.minioUrl;
  return `${baseUrl}/`;
}


export async function fileDownloadUrl() {
  const baseUrl = composeBaseUrl();
  return `${baseUrl}minio/download`;
}
function fileDownloadUrl2() {
  const baseUrl = composeBaseUrl();
  return `${baseUrl}minio/download`;
}
export async function FilterToMap(fields: any) {
  let map = new Map();
  let timeMap = new Map();
  for (let key in fields) {
    if (fields[key] && Array.isArray(fields[key])) {

      //数据库设计时时间字段都规定了必须以Time结尾
      if (key.endsWith("Time")) {
        map = new Map();
        let [startTime, endTime] = fields[key];
        timeMap[`${key}StartTime`] = startTime;
        timeMap[`${key}EndTime`] = endTime;
        delete fields[key];
        fields["params"] = timeMap;
      }
      // }else{
      //     timeMap = new Map();
      //     map[key] = fields[key]
      //     delete fields[key];
      //     fields["params"] = map;
      // }


    }

  }

}

export function getLableFromType(proColumns: ProColumns<any>[], dataIndex: string, type: string) {
  let label = proColumns.filter(column => column.dataIndex === dataIndex).filter(value => value.valueEnum)
    .map(value => value.valueEnum && value.valueEnum[type]?.text)
  //   .map((value:any)=>{return value.text})
  return label && label[0]

}

export function uploadFile(info: any) {
  const { status } = info.file;
  if (status !== 'uploading') {
    // console.log(info.file, info.fileList);
  }
  if (status === 'done') {
    message.success(`${info.file.name} 上传成功`);
  } else if (status === 'error') {
    message.error(`${info.file.name} 上传失败`);
  }
  return info && info.fileList;
}

export function getUserIdFromStorage() {
  return SimpleStorage.get(USER_ID) || 1;
}

export function getDeptIdFromStorage() {
  return SimpleStorage.get(DEPT_ID) || 1;
}

export function getDeptNameFromStorage() {
  return SimpleStorage.get(DEPT_Name) || "GWXX城区XX公司XXXXX领导小组";
}

export function getTokenFromStorage() {
  return SimpleStorage.get(TOKEN);
}


export function saveLoginUserToStorage(user: any, token: string) {
  SimpleStorage.save(LOGIN_INFO, user)
  SimpleStorage.save(USER_ID, user.userId)
  SimpleStorage.save(TOKEN, token)
}

export function deleteLoginUserFromStorage() {
  SimpleStorage.delete(LOGIN_INFO)
  SimpleStorage.delete(USER_ID)
  SimpleStorage.delete(TOKEN)
}

export function getLoginUserFromStorage() {
  return SimpleStorage.get(LOGIN_INFO);

}

export function saveLoginUserPermsToStorage(perm: string[]) {
  SimpleStorage.save(PERM_INFO, perm);
}

/** 从菜单树递归收集 type=F 的按钮权限标识 */
export function extractButtonPermsFromMenus(
  menus: { type?: string; perms?: string; children?: { type?: string; perms?: string; children?: unknown[] }[] }[],
): string[] {
  const result: string[] = [];
  const walk = (items: typeof menus) => {
    for (const item of items) {
      if (item.type === 'F' && item.perms) {
        result.push(item.perms);
      }
      if (item.children?.length) {
        walk(item.children as typeof menus);
      }
    }
  };
  walk(menus);
  return [...new Set(result)];
}

/** 从 localStorage 的 newMenus 同步按钮权限（刷新页面后仍可用） */
export function syncPermsFromStoredMenus(): void {
  try {
    const raw = localStorage.getItem('newMenus');
    if (!raw) return;
    const menus = JSON.parse(raw);
    if (Array.isArray(menus)) {
      saveLoginUserPermsToStorage(extractButtonPermsFromMenus(menus));
    }
  } catch (error) {
    console.error('同步按钮权限失败:', error);
  }
}

function permListIncludes(perms: unknown, perm: string): boolean {
  if (!perms) return false;
  if (Array.isArray(perms)) return perms.includes(perm);
  if (typeof perms === 'string') return perms.split(',').map((s) => s.trim()).includes(perm);
  return false;
}

/** 是否拥有某按钮/操作权限（超级管理员 userId=1 放行） */
export function hasPerm(perm: string): boolean {
  if (getUserIdFromStorage() == 1) return true;
  let perms = SimpleStorage.get(PERM_INFO);
  if (!perms || (Array.isArray(perms) && perms.length === 0)) {
    syncPermsFromStoredMenus();
    perms = SimpleStorage.get(PERM_INFO);
  }
  return permListIncludes(perms, perm);
}


export function userDisplay(list: any[] | undefined) {
  let display = list ? list.map((technicalSupport: any) => {
    if (technicalSupport.sysUser?.phonenumber) return (technicalSupport.sysUser?.loginName + '(' + technicalSupport.sysUser?.phonenumber + ')')
    else return technicalSupport.sysUser?.loginName
  }
  ).join(",") : "--";

  return display;
}

export function getMultipleDescendantPropValue(obj: any, propKeys: string) {
  let keys = propKeys.split(",");
  let val = "";
  for (let i = 0; i < keys.length; i++) {
    if (i == 0) {
      val = getDescendantPropValue(obj, keys[i]);
    }
    else {
      val = val + "[" + getDescendantPropValue(obj, keys[i]) + "]";
    }
  }

  return val;
}


export function getDescendantPropValue(obj: any, propKey: string) {
  //console.log("propKey " + propKey);
  let arr = propKey.split(".");
  let val = obj;
  for (let i = 0; i < arr.length; i++) {
    val = val[arr[i]];
  }
  //console.log("Val values final  : " + JSON.stringify(val));
  return val;
}